import { PATHNAME } from "constants/pathnames";

import {
  HomeOutlined,
  InfoOutlined,
  ContactPhoneOutlined,
  CollectionsOutlined,
  MenuBookOutlined,
  PolicyOutlined,
} from "@mui/icons-material";

export const Menu = [
  {
    id: 1,
    name: "Home",
    path: PATHNAME.heroSection,
    icon: <HomeOutlined />,
    menu: [
      {
        id: "hero_section",
        name: "Hero Section",
        path: PATHNAME.heroSection,
      },
      {
        id: "menu_slider",
        name: "Menu Slider",
        path: PATHNAME.menuSlider,
      },
      {
        id: "pickup_delivery",
        name: "Pickup & Delivery",
        path: PATHNAME.pickupDelivery,
      },
      {
        id: "home_meta_details",
        name: "Meta Details",
        path: PATHNAME.homeMetaDetails,
      },
    ],
  },
  {
    id: 3,
    name: "Menu",
    path: PATHNAME.menuCategories,
    icon: <MenuBookOutlined />,
    menu: [
      {
        id: "menu_categories",
        name: "Categories",
        path: PATHNAME.menuCategories,
      },
      {
        id: "menu_meta_details",
        name: "Meta Details",
        path: PATHNAME.menuMetaDetails,
      },
    ],
  },
  {
    id: 2,
    name: "Gallery",
    path: PATHNAME.products,
    icon: <CollectionsOutlined />,
    menu: [
      {
        id: "gallery_products",
        name: "Products",
        path: PATHNAME.products,
      },
      {
        id: "gallery_meta_details",
        name: "Meta Details",
        path: PATHNAME.galleryMetaDetails,
      },
    ],
  },
  {
    id: 4,
    name: "About Us",
    path: PATHNAME.about,
    icon: <InfoOutlined />,
    menu: [
      {
        id: "about_content",
        name: "Content",
        path: PATHNAME.about,
      },
      {
        id: "about_meta_details",
        name: "Meta Details",
        path: PATHNAME.aboutMetaDetails,
      },
    ],
  },
  {
    id: 5,
    name: "Contact Us",
    path: PATHNAME.contactUsContacts,
    icon: <ContactPhoneOutlined />,
    menu: [
      {
        id: "contact_us_contacts",
        name: "Contacts",
        path: PATHNAME.contactUsContacts,
      },
      {
        id: "contact_us_locations",
        name: "Locations",
        path: PATHNAME.contactUsLocations,
      },
      {
        id: "contact_us_social_media",
        name: "Social Media",
        path: PATHNAME.contactUsSocialMedia,
      },
      {
        id: "contact_us_meta_details",
        name: "Meta Details",
        path: PATHNAME.contactUsMetaDetails,
      },
    ],
  },
  {
    id: 6,
    name: "Privacy Policy",
    path: PATHNAME.privacyPolicy,
    icon: <PolicyOutlined />,
    menu: [
      {
        id: "privacy_policy_content",
        name: "Content",
        path: PATHNAME.privacyPolicy,
      },
      {
        id: "privacy_policy_meta_details",
        name: "Meta Details",
        path: PATHNAME.privacyPolicyMetaDetails,
      },
    ],
  },
];
